const UsersIcon = ({ size = 20, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle
                cx="7.91634"
                cy="7.08333"
                r="3.33333"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0837 9.58333C12.8572 9.58333 13.5991 9.27604 14.1461 8.72906C14.693 8.18208 15.0003 7.44022 15.0003 6.66667C15.0003 5.89312 14.693 5.15125 14.1461 4.60427C13.5991 4.05729 12.8572 3.75 12.0837 3.75"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.91667 12.7222C5.72453 12.7222 4.30912 13.4247 3.88447 14.8454C3.7263 15.3745 4.19771 15.8333 4.75 15.8333H11.0833C11.6356 15.8333 12.107 15.3745 11.9489 14.8454C11.5242 13.4247 10.1088 12.7222 7.91667 12.7222Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.0231 15.4166H14.9932C15.4401 15.4166 15.8562 15.1154 15.8288 14.6694C15.7655 13.6395 14.9928 12.5692 13.333 12.0833"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default UsersIcon
